import { createApp } from 'vue';
import StickyButtonWithCalculator from 'ewi-ui/components/3-organisms/StickyButtonWithCalculator';
import { createPinia } from 'pinia';

const pinia = createPinia();
const apps = [];
window.addEventListener('pageshow', (e) => {
  const allStickyButtons = document.getElementsByClassName('o-stickyButton');

  for (let i = 0; i < allStickyButtons.length; i++) {
    const dataSet = allStickyButtons[i].dataset;
    const app = createApp(StickyButtonWithCalculator, {
      data: dataSet,
      componentId: i,
    });
    app.use(pinia);
    app.mount(allStickyButtons[i]);
    apps.push(app);
  }
});
